// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"745e9f22ee548b44b7d5","524":"090efef920e00b8266c8","927":"e9f2f945ad6710ae507a"}[chunkId] + ".css";
};